export default "__VITE_ASSET__CgEMdWQp__"